
// export const server="https://localhost:7291"


// export const server="https://localhost:7291";


// export const Origin="http://localhost:3000";


export const server = "https://booking-api.eveelz.in";

















